import Layout from 'layout';
import { SpecializeReviewFormEdit } from 'features/SpecializeReview/pages';
import { Can } from 'components/Can';
import { LayoutProvider } from '../layout/context/layoutcontext';

function SpecializeReviewFormEditPage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
        }}
      >
        <Can do="update" on="specialize_review">
          <SpecializeReviewFormEdit />
        </Can>
      </Layout>
    </LayoutProvider>
  );
}

export default SpecializeReviewFormEditPage;
